export { default as PetAttributes } from "./PetAttributes";
